<div class="edit-container" (click)="$event.stopPropagation()">
  <textarea
    #editTextarea
    class="edit-textarea"
    [value]="editText"
    (input)="onEditInput($event)"
    rows="1"
  ></textarea>
  <div class="edit-actions">
    <div class="edit-left-actions">
      <button
        #editEmojiButton
        class="edit-icon-btn"
        type="button"
        aria-label="Insert emoji"
        (click)="$event.stopPropagation(); toggleEditEmojiPicker()"
      >
        <img src="assets/icons/sentiment_satisfied.svg" alt="Emoji" />
      </button>
      <app-emoji-picker-component
        #editEmojiPicker
        [showEmojiPicker]="editEmojiPickerVisible"
        (emojiSelected)="onEditEmojiSelected($event)"
        (closePicker)="closeEditEmojiPicker()"
      ></app-emoji-picker-component>
    </div>
    <div class="edit-right-actions">
      <button class="btn btn--secondary" (click)="onCancel()" [disabled]="isSaving || isDeleting">
        Abbrechen
      </button>
      <button class="btn btn--primary" (click)="onSave()" [disabled]="isSaving || isDeleting">
        Speichern
      </button>
    </div>
  </div>
</div>
